import { render } from "./App.vue?vue&type=template&id=005bf8cb"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=005bf8cb&lang=css"

import exportComponent from "C:\\Users\\Benny\\Desktop\\dev\\croup-terminal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__